import { render, staticRenderFns } from "./TaskDropdown.vue?vue&type=template&id=273bbc86&scoped=true&"
import script from "./TaskDropdown.vue?vue&type=script&lang=js&"
export * from "./TaskDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TaskDropdown.vue?vue&type=style&index=0&id=273bbc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273bbc86",
  null
  
)

export default component.exports